import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MessageCircle, X } from "lucide-react";
import { trackWhatsAppClick } from "@/lib/trackWhatsAppClick";

const WHATSAPP_LINK = "https://api.whatsapp.com/send?phone=5548988653547&text=Ol%C3%A1%2C%20quero%20agendar%20um%20diagn%C3%B3stico%20gratuito";

export const FloatingWhatsApp = () => {
  const [visible, setVisible] = useState(false);
  const [tooltipVisible, setTooltipVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 5000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (!visible) return;
    const interval = setInterval(() => {
      setTooltipVisible(true);
      setTimeout(() => setTooltipVisible(false), 3000);
    }, 15000);
    // Show tooltip once after appearing
    const first = setTimeout(() => {
      setTooltipVisible(true);
      setTimeout(() => setTooltipVisible(false), 3000);
    }, 2000);
    return () => { clearInterval(interval); clearTimeout(first); };
  }, [visible]);

  if (!visible) return null;

  return (
    <motion.div
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      className="fixed bottom-6 right-6 z-50 flex items-end gap-3"
    >
      <AnimatePresence>
        {tooltipVisible && (
          <motion.div
            initial={{ opacity: 0, x: 10 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 10 }}
            className="bg-card text-foreground text-sm font-medium px-4 py-2.5 rounded-xl shadow-lg border border-border whitespace-nowrap"
          >
            Fale com um especialista 💬
          </motion.div>
        )}
      </AnimatePresence>

      <a
        href={WHATSAPP_LINK}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => trackWhatsAppClick('floating')}
        className="group relative w-14 h-14 bg-[#25D366] rounded-full flex items-center justify-center shadow-lg hover:shadow-xl hover:scale-110 transition-all duration-300"
        aria-label="Abrir WhatsApp"
      >
        <MessageCircle className="w-7 h-7 text-white" />
        {/* Pulse ring */}
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-20" />
      </a>
    </motion.div>
  );
};
